// REAL ESTATE SALES READINESS SCREENER — Scoring Engine
// Scale: 0-4 per item. Two dimensions (8 + 7 items), simple average composite.
import { RE_ITEMS, RE_DIMS } from "./questionBank.js";

export const RE_BANDS = [
  { min:0,  max:40, label:"Developing Fit", level:"developing",
    color:"#dc2626", bg:"#fef2f2", border:"#fecaca", icon:"🔴",
    desc:"This profile shows meaningful gaps in the specific psychological demands of commission-only, self-directed real estate sales. This does not mean the candidate cannot succeed — it means additional support (a structured onboarding buddy, guaranteed base draw period, or closer mentorship) would likely be needed to bridge the early pipeline-building period." },
  { min:40, max:60, label:"Moderate Fit", level:"moderate",
    color:"#d97706", bg:"#fffbeb", border:"#fde68a", icon:"🟡",
    desc:"A mixed profile — some genuine alignment with the demands of the role alongside areas that may need active support. Worth a direct conversation about income-volatility tolerance and network-building habits before finalising a hiring decision." },
  { min:60, max:80, label:"Strong Fit", level:"strong",
    color:"#059669", bg:"#f0fdf4", border:"#86efac", icon:"🟢",
    desc:"This profile shows solid alignment with the specific demands of self-directed, commission-based real estate sales — both in tolerance for income volatility and in natural inclination toward the referral-network habits that drive long-run income." },
  { min:80, max:101,label:"Exceptional Fit", level:"exceptional",
    color:"#1d4ed8", bg:"#eff6ff", border:"#bfdbfe", icon:"🔵",
    desc:"A profile strongly aligned with the psychological demands real estate sales places on an agent. Historically, this combination of resilience and network orientation is associated with agents who survive and thrive past the difficult early pipeline-building period." },
];

export function scoreRealEstate(answers) {
  const dimScores = { ERL:0, RNO:0 };
  const dimCounts = { ERL:0, RNO:0 };

  RE_ITEMS.forEach((item, i) => {
    const raw = answers[i];
    if (raw === null || raw === undefined) return;
    dimScores[item.dim] += Number(raw);
    dimCounts[item.dim]++;
  });

  const dimResults = {};
  Object.keys(RE_DIMS).forEach(dim => {
    const raw = dimScores[dim];
    const max = dimCounts[dim] * 4;
    const pct = max > 0 ? Math.round((raw / max) * 100) : 0;
    dimResults[dim] = { raw, max, pct };
  });

  const overallPct = Math.round((dimResults.ERL.pct + dimResults.RNO.pct) / 2);
  const band = RE_BANDS.find(b => overallPct >= b.min && overallPct < b.max) || RE_BANDS[0];

  const lowerDim = dimResults.ERL.pct <= dimResults.RNO.pct ? "ERL" : "RNO";
  const higherDim = lowerDim === "ERL" ? "RNO" : "ERL";

  return {
    dimResults, overallPct, band,
    lowerDim, higherDim,
    scales: { re: overallPct },
    perfAvg: overallPct/10, potAvg: overallPct/10,
    perfBox: overallPct>=80?3:overallPct>=60?2:1,
    potBox: overallPct>=80?3:overallPct>=60?2:1,
  };
}
